<template>
  <div class="columns is-multiline">
    <div class="column is-12 has-text-primary is-italic is-size-5 pdb-0">
      {{ $t('detailOrdreTravailTech.patrimoine.materiel.champs.title') }}
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.materiel.champs.passerelle')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ materielTechnique.passerelle ? $t('general.oui') :  $t('general.non') }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.materiel.champs.typeEclairage')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ materielTechnique.typeEclairage }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.materiel.champs.largeur')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ materielTechnique.largeur }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.materiel.champs.longueur')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ materielTechnique.longueur }}
            </span>
      </b-field>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    materielTechnique: {
      type: Object,
      required: true,
    },
  },
};

</script>
